module.exports = __webpack_public_path__ + "media/images/plans/plan-wedding-story-e80fc855f2278b6c0505461d51b5dca1.jpg";